module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-wood-rovere-naturale-03.d6cdf260.jpg";